import React from 'react';
import { Box, Divider } from '@mui/material';
import BannerTable from 'app/form/BannerTable';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showagentDispatch } from 'reducers/HomeReducer';
import MarkupTable from 'app/form/MarkupTable';
import TransTable from 'app/form/TransTable';

const TransList = () => {
	const { loginInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	useEffect(() => {
		let data = { id: '1' };
		dispatch(showagentDispatch(data));
	}, []);
	return (
		<div>
			<Box
				style={{
					boxShadow:
						'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px',
					padding: 30,
					background: 'white',
				}}>
				<h2>Transaction List</h2>
				<Divider style={{ marginTop: 20, marginBottom: 20 }} />
				<TransTable />
			</Box>
		</div>
	);
};

export default TransList;
